<template>
   <el-container class="content" style="display: block;">
     <div class="" style="width: 80%;height: 80%;object-fit: contain;">
       <img :src="require('@/assets/image/j1.gif')" @click="toHome()" style="object-fit: contain;position: fixed;left: 0;top: 0;z-index: 1005;background-color: #000000;" :style="{'width': screenWidth*0.05+'px','height': screenWidth*0.05+'px'}">
     </div>
     <div class="daohangw" style="position: absolute;right: 50%;top: 30%;" >
       <div style="position: fixed;right: 0;top: 0;" :class="{cdaohang:cshow}" :style="{'width': screenWidth*0.23+'px','height': screenWidth*0.23+'px'}">
         <div class="" style="width: 80%;height: 80%;object-fit: contain;">
           <img :src="require('@/assets/image/h1.gif')" @click="cshows()" style="object-fit: contain;position: fixed;right: 0;top: 0%;background-color: #000000;" :style="{'width': screenWidth*0.12+'px','height': screenWidth*0.12+'px'}">
         </div>
         <div class="" style="object-fit: contain;" v-if="cshow">
                     <img :src="require('@/assets/image/h2.gif')" @click="cshows1()" style="object-fit: contain;position: fixed;right: 13%;top: 3%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
           <ul style="z-index: 1005;position: fixed;right: 12%;top: 15%;background-color: #001524;line-height: 25px;width: 8%;text-indent: 15%;" v-if="cshow1">
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing2')" command="changjing2">宇宙之幂办公岛</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing3')" command="changjing3">宇宙之幂生产总部</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing')" command="changjing">宇宙之幂员工生活区</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing1')" command="changjing1">宇宙之幂深圳总部</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu')" command="renwu">宇宙之幂宇宙人CEO</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu1')" command="renwu1">宇宙之幂宇宙人CTO</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu2')" command="renwu2">宇宙之幂具象人小樱</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu3')" command="renwu3">宇宙之幂具象人小兔</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu4')" command="renwu4">宇宙之幂代言人</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu5')" command="renwu5">宇宙之幂代言人</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu6')" command="renwu6">宇宙之幂职业人安保</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu7')" command="renwu7">宇宙之幂员工保健员</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu8')" command="renwu8">宇宙之幂员工销售员</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu9')" command="renwu9">宇宙之幂员工行政员</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu10')" command="renwu10">宇宙之幂员工的小宠物</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu1')" command="dianpu1">宇宙之幂员工的小咖啡店</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu2')" command="dianpu2">宇宙之幂员工的小奶茶店</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu3')" command="dianpu3">宇宙之幂员工的小饭堂</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu4')" command="dianpu4">宇宙之幂员工的小储蓄所</li>
           </ul>

         </div>
         <div class="" style="object-fit: contain;" v-if="cshow">
           <img :src="require('@/assets/image/h4.gif')" @click="cshows2()" style="object-fit: contain;position: fixed;right: 13%;top: 25%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
           <ul style="z-index: 1005;position: fixed;right: 8%;top: 42%;background-color: #001524;line-height: 25px;width: 18%;text-indent: 5%;" v-if="cshow2">
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company')" command="company">宇宙一次幂(深圳)机器人有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company1')" command="company1">宇宙人(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company2')" command="company2">秘文宇宙(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company3')" command="company3">宇宙职人(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company4')" command="company4">宇宙五次幂(深圳)文娱科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company5')" command="company5">七次幂(深圳)人工智能有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company6')" command="company6">宇宙械人(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company7')" command="company7">宠宠宇宙(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company8')" command="company8">宇宙空间模块(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company9')" command="company9">宇宙映射(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company10')" command="company10">子宇宙群(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company11')" command="company11">软宇宙(深圳)软件有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company12')" command="company12">暗物质(深圳)系统有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company13')" command="company13">宇宙链(深圳)科技有限公司_【宇宙级软件制造】</li>

             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company14')" command="company14">单导(深圳)制造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company15')" command="company15">千亿光子(深圳)科技有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company16')" command="company16">超显电子(深圳)有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company17')" command="company17">沉与浸(深圳)智造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company18')" command="company18">运算盒子(深圳)制造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company19')" command="company19">硅脑(深圳)智造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company20')" command="company20">机甲(深圳)智造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company21')" command="company21">世物诞生(深圳)产业科技有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company22')" command="company22">现品升宙(深圳)科技有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company23')" command="company23">世物宙化(深圳)科技有限公司_【宇宙级硬件制造】</li>

             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company24')" command="company24">产宇宙(深圳)产业科技有限公司_【宇宙级产业制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company25')" command="company25">构宇宙(深圳)产业科技有限公司_【宇宙级产业制造】</li>
           </ul>
         </div>
         <div class="" style="object-fit: contain;" v-if="cshow">
           <img :src="require('@/assets/image/h3.gif')" @click="cshows3()" style="object-fit: contain;position: fixed;right: 1%;top: 25%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
           <ul style="z-index: 1005;position: fixed;right: 0;top: 42%;background-color: #001524;line-height: 25px;width: 8%;text-indent: 15%;" v-if="cshow3">
              <li style="font-size: 15px;color: #ffffff;" @click="toPage('jianjie')" command="jianjie">宇宙之幂简介</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('chanpin')" command="chanpin">宇宙之幂产品线</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('shifang')" command="shifang">宇宙之幂全球释放</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('yingshou')" command="yingshou">宇宙之幂全球营收</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('address')" command="address">宇宙之幂地址</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('contact')" command="contact">联系宇宙之幂</li>
           </ul>
         </div>
       </div>

     </div>
     <div style="display: inline-block;margin-left: 20px;position: fixed;height: 85%;width: 20%;right: 10%;bottom: 0;color: #ffffff;">
          <div style="height: 100%;">
            <div style="height: 6%;background-color: #001422;" >

              <h2 @click="zk()" style="display: inline-block;margin-left: 15%;color:#ffea00 ;">宇宙械人(深圳)科技有限公司</h2>
            </div>
            <div style="height: 100%;background-color: #001422;" v-show="zs">
              <div style="overflow-y: scroll;height: 90%;margin-left: 15%;">
                <div style="margin-top: 5px;" v-for="(item, index) in list" :key="index">{{item.name}}</div>
              </div>
              <div @click="sq()">
                <img :src="require('@/assets/image/sq.png')" style="width: 5%;height: 5%;object-fit: contain;margin-top: 3%;margin-left: 46%;">
              </div>
            </div>
          </div>
     </div>
     <div :style="{'width':screenWidth,'height':screenHeight}">
       <!-- <img :src="require('@/assets/image/changjing/'+cjn)" style="width: 100%;height: 100%;object-fit: contain"> -->
      <img :src="'https://images.yoooooo.com/image/others/changjing/img/qiuti/'+rwn" style="height: 75%;bottom: 10%;left: 30%;" class="qt">


     </div>

    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>
    <!-- <div style="display: none;">
      <div v-for="(item, index) in rw" :key="index">
        <img :src="'https://images.yoooooo.com/image/others/changjing/img/qiuti/'+item" style="" class="renwu">
      </div>

    </div> -->
   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        rw:['7.gif'],
        rwn:'7.gif',

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        cli:false,
        clir:false,
        clio:false,
        list:[],
        zs:true
      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {


      // window.oncontextmenu = function () { return false; };
      // window.onselectstart = function () { return false; };
      // window.onkeydown = window.onkeyup = window.onkeypress = function () {
      //     window.event.returnValue = false;
      //     return false;
      // }

      this.loadList()



    },

	methods:{
    cshows(){
      this.cshow = !this.cshow
      if(!this.cshow){
        this.cshow1 = false
        this.cshow2 = false
        this.cshow3 = false
      }

    },
    cshows1(){
      this.cshow1 = !this.cshow1
      if(this.cshow1){
        this.cshow2 = false
        this.cshow3 = false
      }
    },
    cshows2(){
      this.cshow2 = !this.cshow2
      if(this.cshow2){
        this.cshow1 = false
        this.cshow3 = false
      }
    },
    cshows3(){
      this.cshow3 = !this.cshow3
      if(this.cshow3){
        this.cshow1 = false
        this.cshow2 = false
      }
    },
    toPage(name){
      this.$router.push('/'+name);
    },
    toHome(command) {
      this.$router.push('/');
    },
    zk(){
      this.zs = true
    },
    sq(){
      this.zs = false
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:'宇宙械人(深圳)科技有限公司',


      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadGuanwangCp'
      })
      .then(res=>{
        this.list = res.data.data;


      })
      .catch(err=>{

      });
    },
    vchangeo(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clio = true
      }else{
        this.clio = false
      }
    },
    test(){
      setTimeout(()=>{
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {


          element.style.display = 'none';
          // element.remove()
        });
      },10)

    },
    vchangel(e){

      if(e){
        this.cli = true
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {

          element.style.display = 'none';
          // element.remove()
        });
      }else{
        this.cli = false
      }
    },
    vchanger(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clir = true
      }else{
        this.clir = false
      }
    },
    handleCommand(command) {
      this.$router.push('/'+command);
    },
    startAnimation() {
      var that = this

      this.interval1 = setInterval(() => {
        var bigImgs = that.rw
        var img = bigImgs[Math.floor(Math.random() * bigImgs.length)]
        that.rwn = img
      }, 8000);


    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
  .cdaohang{
    background-color: #000000;
  }
  ul li:hover{
    background-color: #cacaca;
  }
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}
.daohangclicolor{
  color: #cacaca;
}
.daohangnocolor{
  color: #ffffff;
}
.daohangcli{
  height: 50px;
  border: #00b4ff 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #001d31;
}
.daohangno{
  height: 50px;
  border: #686868 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #0071e3;
}
  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }
.qt{
  position: fixed;
  left: 40%;
  bottom: 25%;
  z-index: 1000;

  object-fit: contain;
}
.daohangw{
  position: fixed;
  z-index: 1000;
  left: 40%;
  top:0%;
}
 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }

.daohangcliz{
    height: 50px;
    border: #00b4ff 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #001d31;
  }
  .daohangnoz{
    height: 50px;
    border: #686868 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #0071e3;
  }





</style>



// WEBPACK FOOTER //
// src/components/main/company6.vue